import { API_ERROR_TYPES, APIError } from './client';

const debug = () => {};
// const debug = console.warn.bind(console);

export const createChallengesAPI = (request) => ({
  fetch: async () => {
    debug('Initiating challenges fetch request');
    const result = await request('/challenges-get', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    debug('Challenges fetch completed', {
      success: !!result,
      isArray: Array.isArray(result),
      count: Array.isArray(result) ? result.length : 0
    });
    return result;
  },
  
  create: (data) => {
    debug('Creating challenge with data:', {
      name: data.name,
      category_id: data.category_id,
      team_id: data.team_id,
      status: data.status
    });
    
    if (typeof data !== 'object' || Array.isArray(data)) {
      throw new APIError(
        API_ERROR_TYPES.VALIDATION,
        'Challenge data must be an object',
        400
      );
    }

    const payload = {
      name: data.name || 'New Challenge',
      description: data.description || '',
      category_id: data.category_id || 'uncategorized',
      team_id: data.team_id,
      status: data.status || 'draft',
      is_active: data.is_active ?? true,
      data: {
        ...(data.data || {}),
        opportunities: data.opportunities || [],
        risks: data.risks || [],
        is_draft: true
      }
    };

    debug('Sending challenge create payload');
    return request('/challenges-update', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },
  
  update: (challengeId, data) => {
    debug('Updating challenge:', {
      challengeId,
      category_id: data.category_id
    });
    
    const payload = {
      ...data,
      category_id: data.category_id || 'uncategorized'
    };

    return request(`/challenges-update/${challengeId}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  },
  
  delete: (challengeId) => {
    debug('Deleting challenge:', challengeId);
    return request(`/challenges-update/${challengeId}`, {
      method: 'DELETE'
    });
  }
}); 